export const getLevelCardsData = (levelCounts = {}) => {
  return [
    { title: "Level 1", count: levelCounts?.L1 || 0 },
    { title: "Level 2", count: levelCounts?.L2 || 0 },
    { title: "Level 3", count: levelCounts?.L3 || 0 },
    { title: "Level 4", count: levelCounts?.L4 || 0 }
  ];
};

export const searchFieldOptions = [
  { label: "Name", value: "name" },
  { label: "Email", value: "email" },
  { label: "Phone", value: "phone" },
  { label: "Personal Manager Name", value: "personal_manager_name" },
  { label: "Manager Name", value: "manager_name" },
  { label: "Instagram Handle", value: "ig_handle" },
  { label: "YouTube Handle", value: "yt_handle" }
];

export const creatorTypeOptions = [
  { label: "Celebrity", value: "celebrity" },
  { label: "Influencer", value: "influencers" },
  { label: "Meme Page", value: "meme_pages" },
  { label: "Publisher", value: "publishers" }
];

export const managedByOptions = [
  {
    label: "Self Managed",
    value: "self_managed"
  },
  {
    label: "Personal Managed",
    value: "personal_managed"
  },
  {
    label: "Talent Managed",
    value: "talent_managed"
  }
];

export const contentQualityOptions = [
  { label: "Professional", value: "professional" },
  { label: "Standard", value: "standard" },
  { label: "Studio", value: "studio" }
];

export const paymentTermOptions = [
  { label: "Advance", value: "advance" },
  { label: "Within 30 Days", value: "within_30_days" },
  { label: "Flexible", value: "flexible" },
  { label: "Within 60 Days", value: "within_60_days" }
];

export const barterTypeOptions = [
  { label: "Travel Experience", value: "travel_experience" },
  { label: "High End Products", value: "high_end_products" },
  { label: "Fine Dining", value: "fine_dining" },
  { label: "Exclusive Invites", value: "exclusive_invites" },
  { label: "Gadgets and Devices", value: "gadgets_and_devices" },
  { label: "Ecommerce Credits", value: "ecommerce_credits" },
  { label: "Luxury Stays", value: "luxury_stays" },
  { label: "Premium Products", value: "premium_products" },
  { label: "Luxury Dining", value: "luxury_dining" },
  { label: "Movie Premiers", value: "movie_premiers" },
  { label: "Music Festivals", value: "music_festivals" }
];
